export const environment = {
    production: true,
    serviceName: '',
    baseHref: '/app/',
    froalaKey: 'dKA5cA2F2E2G2E2C2zimekehlC-22dC1phffparzjsoynB2qeuD-13C3B2E2C2E3B1C3C7E2A2=='
};
